const BASE_URL = 'https://pokecardindex.com';

export function generateHomeCanonicalUrl(): string {
  return BASE_URL;
}

export function generateSetCanonicalUrl(seriesSlug: string, setSlug: string): string {
  return `${BASE_URL}/${seriesSlug}/${setSlug}`;
}

export function generateCardCanonicalUrl(seriesSlug: string, setSlug: string, cardSlug: string): string {
  return `${BASE_URL}/${seriesSlug}/${setSlug}/${cardSlug}`;
}

export function generateSeriesCanonicalUrl(seriesSlug: string): string {
  return `${BASE_URL}/${seriesSlug}`;
}

export function generateSearchCanonicalUrl(query: string): string {
  return `${BASE_URL}/search?q=${encodeURIComponent(query)}`;
}

export function generateCollectionCanonicalUrl(): string {
  return `${BASE_URL}/collection`;
} 